import { useEffect } from "react";
import { Amplify } from "aws-amplify";
import Cookie from "js-cookie";

import { isLocalEnvironment } from "../helpers/userLinkHelper";
import { appSyncConfig } from "../../configs/reexports";

type CacheType = Record<string, string>;

const LOCAL_REDIRECT_URL = "http://localhost:3000/";

const createLocalCookieStorage = (hostname: string) => ({
  domain: hostname,
  path: "/",
  expires: 7,
  secure: false,
  sameSite: "lax" as const,
});

export const useSetSharedSession = () => {
  useEffect(() => {
    const amplifyConfig = JSON.parse(JSON.stringify(appSyncConfig));

    const strConfig = Cookie.get("amplify_config");
    let cachedConfig: CacheType = {};

    try {
      cachedConfig = JSON.parse(strConfig ?? "{}");
    } catch (error) {
      console.error("Failed to parse amplify_config cookie:", error);
    }

    const { appClientId } = cachedConfig;
    const isLocal = isLocalEnvironment();

    if (appClientId) {
      amplifyConfig.aws_user_pools_web_client_id = appClientId;

      amplifyConfig.Auth = {
        ...amplifyConfig.Auth,
        userPoolWebClientId: appClientId,
      };
    }

    if (isLocal) {
      amplifyConfig.Auth = {
        ...amplifyConfig.Auth,
        cookieStorage: {
          ...(amplifyConfig.Auth?.cookieStorage ?? {}),
          ...createLocalCookieStorage(window.location.hostname),
        },
        oauth: {
          ...amplifyConfig.Auth?.oauth,
          redirectSignIn: LOCAL_REDIRECT_URL,
          redirectSignOut: LOCAL_REDIRECT_URL,
        },
      };

      amplifyConfig.storage = window.localStorage;
    }

    Amplify.configure(amplifyConfig);
  }, []);
};
